<template>
	<div>
		<div>
			<a href="javascript:history.back()" class="btn btn-outline-secondary mr-2 mb-2" v-if="showBackLink">
				<font-awesome-icon icon="arrow-left"/>
				Vissza
			</a>
		</div>

		<div class="text-center">
			<p>Font Awesome Free License</p>
			<p>-------------------------</p>
			<p><br></p>
			<p>Font Awesome Free is free, open source, and GPL friendly. You can use it for</p>
			<p>commercial projects, open source projects, or really almost whatever you want.</p>
			<p>Full Font Awesome Free license: https://fontawesome.com/license/free.</p>
			<p><br></p>
			<p># Icons: CC BY 4.0 License (https://creativecommons.org/licenses/by/4.0/)</p>
			<p>In the Font Awesome Free download, the CC BY 4.0 license applies to all icons</p>
			<p>packaged as SVG and JS file types.</p>
			<p><br></p>
			<p># Fonts: SIL OFL 1.1 License (https://scripts.sil.org/OFL)</p>
			<p>In the Font Awesome Free download, the SIL OFL license applies to all icons</p>
			<p>packaged as web and desktop font files.</p>
			<p><br></p>
			<p># Code: MIT License (https://opensource.org/licenses/MIT)</p>
			<p>In the Font Awesome Free download, the MIT license applies to all non-font and</p>
			<p>non-icon files.</p>
			<p><br></p>
			<p># Attribution</p>
			<p>Attribution is required by MIT, SIL OFL, and CC BY licenses. Downloaded Font</p>
			<p>Awesome Free files already contain embedded comments with sufficient</p>
			<p>attribution, so you shouldn&apos;t need to do anything additional when using these</p>
			<p>files normally.</p>
			<p><br></p>
			<p>We&apos;ve kept attribution comments terse, so we ask that you do not actively work</p>
			<p>to remove them from files, especially code. They&apos;re a great way for folks to</p>
			<p>learn about Font Awesome.</p>
			<p><br></p>
			<p># Brand Icons</p>
			<p>All brand icons are trademarks of their respective owners. The use of these</p>
			<p>trademarks does not indicate endorsement of the trademark holder by Font</p>
			<p>Awesome, nor vice versa. **Please do not use brand logos for any purpose except</p>
			<p>to represent the company, product, or service to which they refer.**</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "FontAwesomeLicenseView",
	data() {
		return {
			showBackLink: history.length > 1
		}
	}
}

</script>

<style scoped>

</style>
